import { DeviceReadDto } from '../_generated/api/tagged-hardware'
import ApiLifeCycleModel from './ApiLifeCycleModel'

export default class Device extends ApiLifeCycleModel<DeviceReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get serialNo() {
        return this.data.caseSerialNo ?? ''
    }

    get multiMaxSerialNo() {
        return this.data.multiMaxSerialNo ?? ''
    }

    get type() {
        return this.data.machineType ?? ''
    }

    get hardwareVersion() {
        return this.data.hardwareVersion ?? ''
    }

    get softwareVersion() {
        return this.data.softwareVersion ?? ''
    }
}
